import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import addGuestProductToCart from '../../service/addGuestProductCart';
import removeGuestProductFromCart from '../../service/removeGuestProductFromCart';
import showToast from '../../components/ToastComponent';
import Tabs from '../../components/Tabs';
import GuestNonScriptRangeBundles from '../../components/guest/GuestNonScriptRangeBundles';
import { GuestNonScriptRangeProducts } from '../../components/guest/GuestNonScriptRangeProducts';
import { TabItem, AddGuestCartResponse } from '../../interface/interface';
import { GuestCartProvider } from '../../context/guestCartContext';
import FloatingCart from '../../components/FloatingCart';
import isMobile from 'ismobilejs';
import FloatingCartMobile from '../../components/FloatingCartMobile';

export default function GuestNonScriptRange() {
  const [loading, setLoading] = useState(false);

  const addToCartMutation = useMutation({
    mutationFn: async (productId: string) => {
      const result: AddGuestCartResponse =
        await addGuestProductToCart(productId);
      if (result?.success) {
        showToast({
          message: 'Item added to your cart.',
          type: 'success',
        });
      }

      if (result?.status === 405 || result?.data?.message) {
        showToast({
          message: result.data?.message || 'Operation not allowed',
          type: 'warning',
        });
      }
      return result;
    },
    mutationKey: ['addToGuestCart'],
  });

  const removeProductFromCartMutation = useMutation({
    mutationKey: ['removeGuestCartItem'],
    mutationFn: async (productId: string) => {
      const result = await removeGuestProductFromCart(productId);
      if (result?.success) {
        showToast({
          message: 'Item removed from your cart.',
          type: 'success',
        });
      }
      return result;
    },
  });

  useEffect(() => {
    if (
      !loading ||
      !addToCartMutation.isPending ||
      !removeProductFromCartMutation.isPending
    ) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [
    loading,
    addToCartMutation.isPending,
    removeProductFromCartMutation.isPending,
  ]);

  const tabs: Array<TabItem> = [
    {
      id: '1',
      label: 'Products',
      component: (
        <GuestNonScriptRangeProducts
          addToCartMutation={addToCartMutation}
          removeFromCartMutation={removeProductFromCartMutation}
          loading={loading}
        />
      ),
    },
    {
      id: '2',
      label: 'Bundles',
      component: (
        <GuestNonScriptRangeBundles
          addToCartMutation={addToCartMutation}
          removeFromCartMutation={removeProductFromCartMutation}
          loading={loading}
        />
      ),
    },
  ];

  return (
    <GuestCartProvider>
      <Tabs tabs={tabs} />
      {!isMobile().phone ? <FloatingCart /> : <FloatingCartMobile />}
    </GuestCartProvider>
  );
}
